//=require main.js
//=require slick-carousel/slick/slick.min.js

$(document).ready(function (){
    $('.find-style-list').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    })
    //
    // $(document).on("focus","textarea", function(){
    //     $(this).val('');
    //     $(this).blur();
    // });
    // $('textarea').val('Lời nhắn của bạn');

    $('.btn-tu-van').click(function (){
        let spf_name = $('.spf-name').val();
        let spf_email = $('.spf-email').val();
        let spf_phone = $('.spf-phone').val();
        let spf_message = $('.spf-message').val();
        const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const regexPhone = /^[0-9]{10,13}$/;
        if(!spf_name || spf_name == ''){
            $('input.spf-name').css({'border': '1px solid red'});
            return false;
        }
        if(!spf_email || spf_email == ''){
            $('input.spf-email').css({'border': '1px solid red'});
            return false;
        }
        if(!regexEmail.test(String(spf_email).toLowerCase())){
            $('input.spf-email').css({'border': '1px solid red'});
            return false;
        }
        if(!spf_phone || spf_phone == ''){
            $('input.spf-phone').css({'border': '1px solid red'});
            return false;
        }
        if(!regexPhone.test(String(spf_phone).toLowerCase())){
            $('input.spf-phone').css({'border': '1px solid red'});
            return false;
        }
        $('.messageSuccess').show();
    });
    $('input.spf-name').keyup(function (){
        $('input.spf-name').css({'border': '1px solid #ced4da'});
    })
    $('input.spf-email').keyup(function (){
        $('input.spf-email').css({'border': '1px solid #ced4da'});
    })
    $('input.spf-phone').keyup(function (){
        $('input.spf-phone').css({'border': '1px solid #ced4da'});
    })
    $('input.spf-message').keyup(function (){
        $('input.spf-message').css({'border': '1px solid #ced4da'});
    })
})
